import { Flex, Modal, Text, useMantineTheme } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { meetingDate } from "../../utils/date";
import {
  ETypeInstrument,
  IPredictiveProduct,
  IPredictiveProductInstrument,
} from "../../hooks/usePredictives";
import { formatCurrency } from "../../utils/currency";

interface IProps {
  onClose: () => void;
  opened: boolean;
  data: IPredictiveProduct | undefined;
  selectedInstrument: IPredictiveProductInstrument | null;
  selectedSide: ETypeInstrument;
  numberOfContracts: number;
}

export default function SimulationModal({
  onClose,
  opened,
  data,
  selectedInstrument,
  selectedSide,
  numberOfContracts,
}: IProps) {
  const theme = useMantineTheme();
  const { t } = useTranslation();

  return (
    <Modal
      opened={!!opened}
      onClose={onClose}
      centered
      size="auto"
      transitionProps={{
        transition: "slide-up",
        duration: 300,
        timingFunction: "linear",
        exitDuration: 0,
      }}
      styles={{
        content: {
          borderRadius: "12px",
          boxShadow: "0px 25px 35px rgba(0, 0, 0, 0.03)",
        },
        header: {
          padding: "0",
        },
        inner: {
          background: "rgba(0, 0, 0, 0.6)",
        },
        body: { padding: "0px " },
      }}
      withCloseButton={false}
    >
      <Flex direction="column">
        <Flex>
          <Text
            style={{
              color: theme.colors.complementary[7],
              background: theme.colors.complementaryOpacity[7],
              padding: "0.4rem 0.7rem",
              borderRadius: "0.5rem",
              fontSize: "0.7rem",
              fontWeight: 600,
              textAlign: "center",
              flex: "1",
            }}
          >
            {t("global.predictives_buy_card.simulate_modal.title")}
          </Text>
        </Flex>

        <Flex direction="column">
          <Flex gap="10px" w="100%" justify="space-between" align="center">
            <Text
              style={{
                color: theme.colors.complementary[3],
                background: theme.colors.complementaryOpacity[3],
                padding: "0.4rem 0.7rem",
                borderRadius: "0.5rem",
                fontSize: "0.7rem",
                fontWeight: 600,
                textAlign: "center",
                whiteSpace: "nowrap",
                flex: "1",
              }}
            >
              {meetingDate({
                date: data?.expiration || "",
                category: data?.category || "",
                t,
              })}
            </Text>
            {selectedInstrument && (
              <Text
                style={{
                  color: theme.colors.complementary[7],
                  background: theme.colors.complementaryOpacity[7],
                  padding: "0.4rem 0.7rem",
                  borderRadius: "0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: 600,
                  textAlign: "center",
                  flex: "1",
                }}
              >
                {selectedInstrument.label}
              </Text>
            )}
          </Flex>

          <Flex>
            {data?.instruments.map((instrument) => {
              const calc = instrument.calculated_ask;

              return (
                <Flex direction={"column"} key={instrument.id}>
                  <Text>{instrument.label}</Text>
                  <Text>{formatCurrency(calc)}</Text>
                </Flex>
              );
            })}
          </Flex>
        </Flex>
      </Flex>
    </Modal>
  );
}
